/**
 * @generated SignedSource<<1adf87a66eaffffa2b0c265cfa48f644>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_query$data = {
  readonly jira_isBetaAiFeaturesEnabled: boolean | null;
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudUrl: AGG$URL | null;
  } | null> | null;
  readonly " $fragmentType": "footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_query";
};
export type footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_query$key = {
  readonly " $data"?: footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "kind": "ScalarField",
      "name": "jira_isBetaAiFeaturesEnabled"
    },
    {
      "args": [
        {
          "items": [
            {
              "kind": "Variable",
              "name": "cloudIds.0",
              "variableName": "cloudId"
            }
          ],
          "kind": "ListValue",
          "name": "cloudIds"
        }
      ],
      "concreteType": "TenantContext",
      "kind": "LinkedField",
      "name": "tenantContexts",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "cloudUrl"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "bb842cd232d1b12e9c7fa38b40662a57";

export default node;
